// src/pages/register.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/styles.css';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function Register({ setUser }) {
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    if (localStorage.getItem('currentUser')) {
      navigate('/');
    }
  }, [navigate]);

  function getCaptchaToken(action) {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha?.enterprise) {
        reject(new Error('reCAPTCHA no está cargado'));
        return;
      }
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(SITE_KEY, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      // 1) Obtén el token
      const captchaToken = await getCaptchaToken('REGISTER');
      // 2) Llama al backend
      const resp = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, captchaToken })
      });

      const data = await resp.json();
      if (!resp.ok) {
        throw new Error(data.message || 'Error al registrar.');
      }

      // 3) Éxito: guarda el usuario y redirige
      localStorage.setItem('currentUser', JSON.stringify(data.user));
      setUser(data.user);
      navigate('/');
    } catch (err) {
      console.error('Registro fallido:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Registrarse</h2>
      <form onSubmit={handleSubmit} className="auth-form">
        {error && <p className="error-message">{error}</p>}

        <label htmlFor="email">Correo Electrónico:</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password">Contraseña:</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />

        <label htmlFor="confirm">Confirmar Contraseña:</label>
        <input
          id="confirm"
          type="password"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          required
        />

        <button type="submit" className="btn-submit" disabled={loading}>
          {loading ? 'Registrando...' : 'Registrarse'}
        </button>

        <p style={{ marginTop: '1rem', color: 'var(--color-text-secondary)' }}>
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión aquí</Link>
        </p>
      </form>
    </div>
  );
}
